import React, { createContext, useState, useEffect } from 'react';

// Create a context
export const UserContext = createContext();

// UserProvider to wrap around your app and provide user info
export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  // Retrieve user from localStorage if available
  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  // Store user in localStorage whenever it changes
  const saveUser = (userData) => {
    localStorage.setItem('user', JSON.stringify(userData));
    setUser(userData);
  };

  return (
    <UserContext.Provider value={{ user, saveUser }}>
      {children}
    </UserContext.Provider>
  );
};
